const menuItems = document.querySelectorAll('li.ettika--header--menu--list > mega-menu');
menuItems.forEach(megaMenu => {
  const li = megaMenu.parentElement;
  const holdDiv = megaMenu.querySelector('.ettika--header--megamenu--hold');

  const setActive = () => {
    li.classList.add('active');
    holdDiv?.classList.add('active');
    document.body.classList.add('active--header--megamenu');
  };

  const removeActive = () => {
    li.classList.remove('active');
    holdDiv?.classList.remove('active');
    document.body.classList.remove('active--header--megamenu');
  };

  [li, holdDiv].forEach(el => {
    if (!el) return;
    el.addEventListener('mouseenter', setActive);
    el.addEventListener('mouseleave', e => {
      const related = e.relatedTarget;
      if (!li.contains(related) && !(holdDiv && holdDiv.contains(related))) {
        removeActive();
      }
    });
  });
});




// mobile--menu--opener-js
document.querySelector('.ettika--toggle--menu--icon').addEventListener('click', function(e) {
  e.preventDefault();
  document.querySelector('.ettika--mobile--menu').classList.add('open--ettika');
});
document.querySelectorAll('.mobile--menu--cross--icon').forEach(btn => {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    document.querySelector('.ettika--mobile--menu').classList.remove('open--ettika');
    document.querySelectorAll('.products--inner--drawer.product--inner--drawer--open').forEach(drawer => {
      drawer.classList.remove('product--inner--drawer--open');
    });
  });
});
document.querySelectorAll('.has--product--drawer--menu').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();
    const drawer = this.nextElementSibling;
    if(drawer && drawer.classList.contains('products--inner--drawer')) {
      drawer.classList.add('product--inner--drawer--open');
    }
  });
});

document.querySelectorAll('.go--back--collection--title').forEach(btn => {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    const drawer = this.closest('.products--inner--drawer');
    if(drawer) {
      drawer.classList.remove('product--inner--drawer--open');
    }
  });
});


// menu-grid-show-next-after-six-li
  document.addEventListener('DOMContentLoaded', function () {
    const lists = document.querySelectorAll('.megamenu--shop--by--list');
    lists.forEach(list => {
      if (list.classList.contains('mega--shop--by--list--everywhere')) return;
      const itemCount = list.querySelectorAll('li').length;
      if (itemCount > 7) {
        list.classList.add('two-column-layout');
      }
    });
  });



  document.addEventListener("DOMContentLoaded", function () {
    const headerWrapper = document.querySelector('.ettika--main--header--wrapper');
    const headerTop = document.querySelector('.ettika--main--header--links');
    const placeholder = document.getElementById('sticky-header-placeholder');

    const updateStickyHeader = () => {
      const topRect = headerTop.getBoundingClientRect();

      if (topRect.bottom <= 0) {
        if (!headerWrapper.classList.contains('fixed')) {
          const height = headerWrapper.offsetHeight;
          placeholder.style.height = height + 'px';
          placeholder.style.display = 'block';
          headerWrapper.classList.add('fixed');
        }
      } else {
        headerWrapper.classList.remove('fixed');
        placeholder.style.display = 'none';
      }
    };

    window.addEventListener('scroll', updateStickyHeader);
    window.addEventListener('resize', () => {
      if (headerWrapper.classList.contains('fixed')) {
        placeholder.style.height = headerWrapper.offsetHeight + 'px';
      }
    });
  });